import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import NoContentAdded, { NO_REVIEWER } from "NoContentAdded";
import Pagination from "react-js-pagination";
import { IMAGE_PATH, itemCount, COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import LocaleStrings from "Languages";
import {
  openChangeReviewer,
  fetchReviewerList,
  changeReviewer,
  fetchResponseList,
  fetchallproposal,
  updatedDragProposal,
  openProposalResponseModal,
} from "ProposalAction";

class ChangeReviewer extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = { loading: false, selectedReviewer: "" };
  }

  componentDidMount() {
    this.props.fetchReviewerList(this.props.session);
  }

  closeModal() {
    this.props.openChangeReviewer(false, "");
  }

  onSubmitForm = (values) => {
    let { showChangeReviewer } = this.props;
    let proposalidfk =
      showChangeReviewer.response && showChangeReviewer.response.proposalidfk
        ? showChangeReviewer.response.proposalidfk
        : "";
    let id =
      showChangeReviewer.response && showChangeReviewer.response.id
        ? showChangeReviewer.response.id
        : "";
    values.id = id;
    values.reviewerid = values.reviewerid == "" ? null : values.reviewerid;
    this.setState({ loading: true });
    this.props.changeReviewer(
      this.props.session,
      values,
      proposalidfk,
      (response) => {
        //console.log('proposal',response);
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          document.getElementById("sortbyHandle").value = "none";
          // this.props.fetchResponseList(this.props.session, "unreviewed");
          this.props.fetchallproposal(this.props.session, (callback) => {
            this.props.updatedDragProposal(true);
          });
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.proposal_reviewer_change_succesfully
          );
        }
        this.props.reset();
        this.closeModal();
        this.props.openProposalResponseModal(false, "", "");
      }
    );
  };

  renderFieldRadio(field) {
    return (
      <div>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  handleSelect = (e) => {
    let reviewerid = e.target.value;
    this.setState({ selectedReviewer: parseInt(reviewerid) });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      showChangeReviewer,
      appUserreviewerList,
      initialValues,
    } = this.props;
    //console.log("initialValues", initialValues);
    let appUserList =
      appUserreviewerList &&
      appUserreviewerList.data &&
      appUserreviewerList.data.length > 0
        ? appUserreviewerList.data
        : [];
    //console.log("appUserList 1", appUserList);

    //console.log("reviewerid", showChangeReviewer.response.reviewerid);
    let assinedUser = [];
    if (
      showChangeReviewer.response &&
      showChangeReviewer.response.reviewerid &&
      appUserList &&
      appUserList.length > 0
    ) {
      assinedUser = _.filter(appUserList, function (o) {
        return o.appuserid == showChangeReviewer.response.reviewerid;
      });

      // appUserList = _.filter(appUserList, function (o) {
      //   return o.appuserid != showChangeReviewer.response.reviewerid;
      // });
      //console.log('appUserList 2',appUserList);
    }
    //console.log("showChangeReviewer.response", showChangeReviewer.response);

    return (
      <div>
        <Modal
          className="modal-container"
          enforceFocus={false}
          show={showChangeReviewer.showModal === true ? true : false}
          animation={true}
          dialogClassName="changereviewermodal"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.reviewer_change_text}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Body>
              {showChangeReviewer.response &&
              showChangeReviewer.response.proposal_by_proposalidfk ? (
                <div className="d-flex" style={{ marginBottom: "10px" }}>
                  <div className="" style={{ fontWeight: 700 }}>
                    {" "}
                    {
                      LocaleStrings.proposal_wizard_reviewer_distribution_text
                    }{" "}
                    :-
                  </div>
                  <div
                    className=""
                    style={{ paddingLeft: "20px", fontWeight: 700 }}
                  >
                    {" "}
                    {_.startCase(
                      showChangeReviewer.response.proposal_by_proposalidfk
                        .distribution
                    )}
                  </div>
                  <div className="">
                    <i
                      className="fa fa-exclamation-circle changereviewer-tooltip"
                      style={{
                        marginLeft: "6px",
                        marginTop: 2,
                        cursor: "pointer",
                      }}
                      aria-hidden="true"
                    ></i>
                    <div className="changereviewer-tooltiptext">
                      {showChangeReviewer.response.proposal_by_proposalidfk
                        .distribution == "manual"
                        ? LocaleStrings.reviewer_distribution_manual
                        : showChangeReviewer.response.proposal_by_proposalidfk
                            .distribution == "random"
                        ? LocaleStrings.reviewer_distribution_random
                        : LocaleStrings.reviewer_distribution_circular}
                    </div>
                  </div>

                  {/* <label className="col-sm-4">
                    {LocaleStrings.proposal_wizard_reviewer_distribution_text}{" "}
                    :-
                  </label>
                  <label className="col-sm-8">
                    {_.startCase(
                      showChangeReviewer.response.proposal_by_proposalidfk
                        .distribution
                    )}
                  </label>
                  <label className="col-sm-4"></label>
                  <label className="col-sm-8">
                    {showChangeReviewer.response.proposal_by_proposalidfk
                      .distribution == "manual"
                      ? LocaleStrings.reviewer_distribution_manual
                      : showChangeReviewer.response.proposal_by_proposalidfk
                          .distribution == "random"
                      ? LocaleStrings.reviewer_distribution_random
                      : LocaleStrings.reviewer_distribution_circular}
                  </label> */}
                </div>
              ) : (
                ""
              )}

              {appUserList && appUserList.length > 0 ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {LocaleStrings.proposal_wizard_reviewerlist}
                  </label>
                  <div className="col-sm-12 col-sm-offset-0">
                    {_.map(appUserList, (opt, index) => {
                      return (
                        <div key={index} style={{ marginBottom: 5 }}>
                          <Field
                            name="reviewerid"
                            label={opt.firstname + " " + opt.lastname}
                            value={opt.appuserid.toString()}
                            type="radio"
                            component={this.renderFieldRadio}
                            onChange={this.handleSelect}
                          />
                        </div>
                      );
                    })}
                    <div
                      key={appUserList.length + 1}
                      style={{ marginBottom: 5 }}
                    >
                      <Field
                        name="reviewerid"
                        label={"Unassigned"}
                        value={""}
                        type="radio"
                        component={this.renderFieldRadio}
                        onChange={this.handleSelect}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                bsStyle=""
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                bsStyle=""
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.reviewer_change_button}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}
function mapStateToProps(state) {
  var initVals = {};
  if (
    state.showChangeReviewer &&
    state.showChangeReviewer.response.reviewerid
  ) {
    initVals.reviewerid =
      state.showChangeReviewer.response.reviewerid.toString();
  }

  return {
    session: state.session,
    showChangeReviewer: state.showChangeReviewer,
    appUserreviewerList: state.appUserreviewerList,
    initialValues: initVals,
  };
}

function validate(values) {
  // console.log('values',values);
  var errors = {};
  var proposal_name = values["proposal_name"];
  var proposaldesc = values["proposaldesc"];

  if (!proposal_name) {
    errors["proposal_name"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!proposaldesc) {
    errors["proposaldesc"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }

  return errors;
}

export default connect(mapStateToProps, {
  openChangeReviewer,
  showError,
  showSuccess,
  fetchReviewerList,
  changeReviewer,
  fetchResponseList,
  fetchallproposal,
  updatedDragProposal,
  openProposalResponseModal,
})(
  reduxForm({
    validate,
    form: "ProposalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ChangeReviewer)
);
